import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smartphoneapp-page',
  templateUrl: './smartphoneapp-page.component.html',
  styleUrls: ['./smartphoneapp-page.component.scss']
})
export class SmartphoneappPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
